import { render, staticRenderFns } from "./RelatorioTotalizadores.vue?vue&type=template&id=3f0c293f&lang=pug"
import script from "./RelatorioTotalizadores.vue?vue&type=script&lang=js"
export * from "./RelatorioTotalizadores.vue?vue&type=script&lang=js"
import style0 from "./RelatorioTotalizadores.vue?vue&type=style&index=0&id=3f0c293f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports